import dayjs from 'dayjs'
import { fetchActivities, fetchWorkflows } from '../shared/redtailQueryHelpers'
import RedtailTaskPanel from './RedtailTaskPanel'
import RedtailWorkflowPanel from './RedtailWorkflowPanel'

function filterIncompleteTasks (activities, config) {
  const categoryIds = config?.categoryIds
  const priorityFilter = config?.priorityFilter
  return activities.filter(a => {
    if (a.activity_code_id !== 1 || a.completed) return false
    if (categoryIds?.length && !categoryIds.includes(a.category_id)) return false
    if (priorityFilter?.length && !priorityFilter.map(String).includes(String(a.priority))) return false
    return true
  })
}

const pastDueTasks = {
  key: 'past-due-tasks',
  displayName: 'Past Due Tasks',
  defaults: {
    icon: 'redtailSmall',
    title: 'Past Due',
    label: 'Incomplete Tasks',
    format: '0,0'
  },

  async fetchData (members, clientId) {
    return fetchActivities(members, clientId, {
      start_date: dayjs().subtract(1, 'year').format('YYYY-MM-DD'),
      end_date: dayjs().format('YYYY-MM-DD')
    })
  },

  compute: filterIncompleteTasks,

  DetailPanel: RedtailTaskPanel
}

const dueWithin = {
  key: 'due-within',
  displayName: 'Due Within',
  defaults: {
    icon: 'redtailSmall',
    title: 'Open Tasks',
    label: 'Due This Week',
    format: '0,0'
  },

  async fetchData (members, clientId, config) {
    const dueWithinDays = config?.dueWithinDays ?? 7
    return fetchActivities(members, clientId, {
      start_date: dayjs().format('YYYY-MM-DD'),
      end_date: dayjs().add(dueWithinDays, 'day').format('YYYY-MM-DD')
    })
  },

  compute: filterIncompleteTasks,

  DetailPanel: RedtailTaskPanel
}

const openWorkflows = {
  key: 'open-workflows',
  displayName: 'Open Workflows',
  defaults: {
    icon: 'redtailSmall',
    title: 'Active Workflows',
    label: null,
    format: '0,0'
  },

  async fetchData (members, clientId) {
    return fetchWorkflows(members, clientId, { open: true })
  },

  compute (workflows) {
    return workflows
  },

  DetailPanel: RedtailWorkflowPanel
}

const presets = {
  'past-due-tasks': pastDueTasks,
  'due-within': dueWithin,
  'open-workflows': openWorkflows
}

export default presets
